import React from "react";

const Header = ({ setOpenSideBar }) => {
  return (
    <div className="w-full float-left header">
      <div className="float-left">
        <svg
          className="h-5 w-5 text-black-500"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" />
          <line x1="9" y1="6" x2="20" y2="6" />
          <line x1="9" y1="12" x2="20" y2="12" />
          <line x1="9" y1="18" x2="20" y2="18" />
          <line x1="5" y1="6" x2="5" y2="6.01" />
          <line x1="5" y1="12" x2="5" y2="12.01" />
          <line x1="5" y1="18" x2="5" y2="18.01" />
        </svg>
      </div>
      <div className="float-left font-bold text-sm ml-3 font-position">
        Table of Contents
      </div>
      <div
        className="inline-block float-right cursor-pointer"
        onClick={() => setOpenSideBar(false)}
      >
        <svg
          className="h-5 w-5 text-gray-500"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </div>
    </div>
  );
};

export default Header;
